<template>
    <Card :padding="0">
        <!--标题-->
        <p slot="title" class="card-title" v-if="showTitle">
            {{chartsTitle}}
        </p>
        <!--查看更多-->
        <a href="#" slot="extra" v-show="showMore" @click.prevent="changeLimit">
            查看更多
        </a>
        <!--图表-->
        <div :style="{height: height}">
            <div style="width:100%;height:100%;" :id="chartsId" v-show="!isShow"></div>
            <div class="chart-error" v-show="isShow">
                <div class="detail">
                    <span class="detail">暂无数据</span>
                </div>
            </div>
        </div>
    </Card>
</template>

<script>
    export default {
        name: "tran-histogram",
        props: {
            //图表标题
            chartsTitle: String,
            //图表id
            chartsId: String,
            //是否显示‘查看更多’
            showMore: {
                type: Boolean,
                default: false
            },
            //是否支持柱状图的点击
            clickCharts: {
                type: Boolean,
                default: false
            },
            //是否显示图表标题
            showTitle: {
                type: Boolean,
                default: true
            },
            //是否显示图例说明
            showLegend: {
                type: Boolean,
                default: false
            },
            //是否显示tooltip
            showTooltip: {
                type: Boolean,
                default: true
            },
            //是否需要自定义tooltip
            isCustomTooltipContent: {
                type: Boolean,
                default: true
            },
            //tooltip头部文字
            tooltipHead: {
                type: String,
                default: ""
            },
            //tooltip单位
            tooltipCompany: {
                type: String,
                default: ""
            },
            //是否展示isShowDataZoom
            isShowDataZoom: {
                type: Boolean,
                default: false
            },
            //是否停止DataZoom的功能
            isDisableDataZoom: {
                type: Boolean,
                default: true
            },
            //文字颜色
            fontColor: {
                type: String,
                default: '#757C8C'
            },
            //文字大小
            fontSize: {
                type: String,
                default: '12px'
            },
            //柱状图的颜色
            colorArr: {
                type: Array,
                default: () => [
                    {offset: 0, color: "#39C6E9"},
                    {offset: 0.5, color: "#A3E5F5"},
                    {offset: 1, color: "#A3E5F5"}
                ]
            },
            //距离上下左右的距离
            grid: {
                type: Object,
                default: () => {
                    return {
                        left: '3%',
                        right: '10%',
                        bottom: '10%',
                        top: '5%',
                        containLabel: true
                    };
                }
            },
            //图表高度
            height: {
                type: String,
                default: '300px'
            },
            //是否间隔显示文字
            isIntervalDisplay: {
                type: Boolean,
                default: false
            },
            //间隔参数
            intervalNum: {
                type: String,
                // default: Math.round(this.xDataArr.length / 10)
                default: 0
            },
            //是否倾斜文字
            isDipData: {
                type: Boolean,
                default: false
            },
            //文字倾斜度
            dipRotate: {
                type: Number,
                default: 40
            },
            //文字过长是否换行
            isWrapData: {
                type: Boolean,
                default: false
            },
            //文字过长是否隐藏
            isHideData: {
                type: Boolean,
                default: false
            },
            //文字换行或隐藏的文字字数限制
            textLimitNum: {
                type: Number,
                default: 5
            },
            //是否在柱状图上显示数据
            isShowDataRemind: {
                type: Boolean,
                default: true
            },
            //数据展示位置
            dataRemindPosition: {
                type: String,
                default: 'right'
            },
            //是否需要自定义文字内容
            isCustomTextContent: {
                type: Boolean,
                default: true
            },
            //是否需要显示轴线数据单位
            isShowCompany: {
                type: Boolean,
                default: false
            },
            //轴数据单位
            dataCompany: {
                type: String,
                default: ""
            },
            //是否显示x轴轴线
            xAxisLine: {
                type: Boolean,
                default: false
            },
            //是否显示y轴轴线
            yAxisLine: {
                type: Boolean,
                default: false
            },
            //是否显示x轴刻度线
            xAxisTick: {
                type: Boolean,
                default: false
            },
            //是否显示y轴刻度线
            yAxisTick: {
                type: Boolean,
                default: false
            },
            //是否显示y轴方向的网格线
            xSplitLine: {
                type: Boolean,
                default: false
            },
            //是否显示x轴方向的网格线
            ySplitLine: {
                type: Boolean,
                default: false
            },
            //设置柱状图每根柱子的最大宽度
            barMaxWidth: {
                type: String,
                default: '20'
            },
            //设置柱状图柱子间的间隔
            barGap: {
                type: String,
                default: '50%'
            }
        },
        data() {
            return {
                isShow: false//默认不展示缺醒图
            }
        },
        methods: {
            /**
             * 查看更多数据
             */
            changeLimit() {
                this.$emit('look-more-data', this.chartsId, this.productKey);
            },
            /**
             *渲染图表
             */
            initDataSource(isShow, xDataArr, seriesDataArr) {
                let _this = this;
                _this.isShow = !isShow;
                let dataSource = _this.$echarts.init(
                    document.getElementById(_this.chartsId)
                );
                dataSource.off('click');
                const option = {
                        tooltip: {
                            show: true,
                            trigger: "axis",
                            axisPointer: {
                                // 坐标轴指示器，坐标轴触发有效
                                type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                            },
                            // 自定义悬浮框内容
                            formatter: function (params) {
                                var htmlStr = '<div>';
                                //如果需要自定义tooltip的内容
                                if (_this.isCustomTooltipContent) {
                                    var color = _this.colorArr[0].color;//图例颜色
                                    htmlStr += params[0].name + '<br/>';//x轴的名称
                                    //添加圆点
                                    htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';
                                    //添加一个汉字，动态的自定义文本内容
                                    htmlStr += _this.tooltipHead + params[0].value + _this.tooltipCompany;
                                    htmlStr += '</div>';
                                }
                                return htmlStr;
                            }
                        },
                        legend: {
                            show: _this.showLegend,
                            data: xDataArr
                        },
                        dataZoom: [
                            {
                                show:_this.isShowDataZoom,
                                disabled:_this.isDisableDataZoom,
                                type: 'slider',
                                yAxisIndex: 0,
                                filterMode: 'empty'
                            },
                            {
                                show:_this.isShowDataZoom,
                                disabled:_this.isDisableDataZoom,
                                type: 'inside',
                                yAxisIndex: 0,
                                filterMode: 'empty'
                            }
                        ],
                        title: {
                            show: _this.showTitle,
                            text: _this.chartsTitle
                        },
                        grid: _this.grid,
                        xAxis: {
                            show: false,
                            type: 'value',
                            boundaryGap: [0, 0.01],
                            axisLine: {
                                show: _this.xAxisLine
                            },
                            axisTick: {
                                show: _this.xAxisTick
                            },
                            splitLine: {
                                show: _this.xSplitLine
                            }
                        },
                        yAxis: {
                            type: 'category',
                            max: xDataArr.length - 1,
                            inverse: true,//倒叙
                            data: xDataArr,
                            show: true,
                            axisLine: {
                                show: _this.yAxisLine
                            },
                            axisTick: {
                                show: _this.yAxisTick
                            },
                            splitLine: {
                                show: _this.ySplitLine
                            },
                            axisLabel: {
                                color: _this.fontColor,
                                interval: _this.isIntervalDisplay === true ? _this.intervalNum : 0,
                                rotate: _this.isDipData === true ? _this.dipRotate : 0,
                                //坐标轴刻度标签的相关设置。
                                formatter: function (params) {
                                    var newParamsName = "";// 最终拼接成的字符串
                                    if (_this.isWrapData) {
                                        var paramsNameNumber = params.length;// 实际标签的个数
                                        var rowNumber = Math.ceil(paramsNameNumber / _this.textLimitNum);// 换行的话，需要显示几行，向上取整
                                        //判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                                        if (paramsNameNumber > _this.textLimitNum) {
                                            /** 循环每一行,p表示行 */
                                            for (var p = 0; p < rowNumber; p++) {
                                                var tempStr = "";// 表示每一次截取的字符串
                                                var start = p * _this.textLimitNum;// 开始截取的位置
                                                var end = start + _this.textLimitNum;// 结束截取的位置
                                                // 此处特殊处理最后一行的索引值
                                                if (p == rowNumber - 1) {
                                                    // 最后一次不换行
                                                    tempStr = params.substring(start, paramsNameNumber);
                                                } else {
                                                    // 每一次拼接字符串并换行
                                                    tempStr = params.substring(start, end) + "\n";
                                                }
                                                newParamsName += tempStr;// 最终拼成的字符串
                                            }

                                        } else {
                                            // 将旧标签的值赋给新标签
                                            newParamsName = params;
                                        }
                                    } else if (_this.isHideData) {
                                        newParamsName = params.length > 5 ? params.substring(0, 5) + '...' : params;
                                    } else {
                                        newParamsName = params;
                                    }
                                    //将最终的字符串返回
                                    return newParamsName
                                }
                            }
                        },
                        series: [
                            {
                                data: seriesDataArr,
                                type: 'bar',
                                barCateGoryGap: _this.barGap,
                                barWidth: _this.barMaxWidth,//柱图宽度
                                itemStyle: {
                                    normal: {
                                        label: {
                                            show: _this.isIntervalDisplay !== true, //开启显示
                                            position: "right", //在右方显示
                                            textStyle: {
                                                //数值样式
                                                color: _this.fontColor,
                                                fontSize: _this.fontSize
                                            }
                                            ,
                                            formatter: function (params) {
                                                if (params.value > 1000) {
                                                    let value = parseInt(params.value / 1000);
                                                    return value + '千+';
                                                } else if (params.value > 10000) {
                                                    let value = parseInt(params.value / 10000);
                                                    return value + '万+';
                                                } else {
                                                    return params.value + _this.tooltipCompany;
                                                }
                                            }
                                        }
                                        ,
                                        color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, _this.colorArr)
                                    }
                                }
                            }
                        ]
                    }
                ;
                dataSource.setOption(option);
                if (_this.clickCharts) {
                    // dataSource.on('click', function (params) {
                    //     _this.$emit('click-more-data', params, _this.chartsId);
                    // });
                    dataSource.getZr().on('click',function (params) {
                        var pointInPixel= [params.offsetX, params.offsetY];
                        if (dataSource.containPixel('grid',pointInPixel)) {
                            /*此处添加具体执行代码*/

                            var pointInGrid=dataSource.convertFromPixel({seriesIndex:0},pointInPixel);
                            //X轴序号
                            var xIndex=pointInGrid[1];

                            //获取当前图表的option
                            var op=dataSource.getOption();
                            //获得图表中我们想要的数据
                            var objectParams=op.series[0].data[xIndex].id;
                            _this.$emit('click-more-data', 'his',objectParams, _this.chartsId, _this.productKey);
                        }
                    });
                }
                window.addEventListener("resize", function () {
                    dataSource.resize();
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../style/common";
</style>